<template>
    <div class="card shadow p-4 py-5 h-100">
        <section class="title">{{ $t('REGISTRATION_CONFIRMED_TITLE') }}</section>
        <section v-dompurify-html="$t('REGISTRATION_CONFIRMED_TEXT')"></section>
    </div>
</template>

<script>
export default {
    
}
</script>

<style lang="scss" scoped>
</style>